import CryptoJS from 'crypto-js';

class Encryption {

    randomString(lenght) {
        var result = '';
        var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
        for (var i = lenght; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
        return result;
    }

    decrypt(encryptedString) {
        var key = CryptoJS.enc.Utf8.parse("eTJmS3F6UlM5SVlSRG5sa1owOUF4dEpk");
        var iv = CryptoJS.enc.Utf8.parse(encryptedString.substring(0, 16));
        var encrypted = encryptedString.substring(16);
        var decrypted = CryptoJS.AES.decrypt(encrypted, key, { iv: iv });
        return decrypted.toString(CryptoJS.enc.Utf8);
    }

    encrypt(string) {
        var key = CryptoJS.enc.Utf8.parse("eTJmS3F6UlM5SVlSRG5sa1owOUF4dEpk");
        var randomStr = this.randomString(16);
        var iv = CryptoJS.enc.Utf8.parse(randomStr);
        var encrypted = CryptoJS.AES.encrypt(string, key, { iv: iv });
        var encryptedString = randomStr + CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
        return encryptedString;
    }
}

export default Encryption;